/* Add p_filterKey,p_filterFirstKey Dec 30, 2023 */
/* Add required Feb 1, 2025 */
<template lang="pug">
	div(class="kt-list" :class="p_readOnly ? 'read-only':''")
		div(class="list-outer")
			div(class="list-inner")
				div(class="list-content" :class="d_showAll ? 'show-all' : null" :style="!d_showAll ? 'height:unset': null")
					//- Added Items
					div(class="list-item" v-for="(d,ix) in d_added" :key="ix" v-if="ix<3 || d_showAll")
						b-input-group-prepend
							b-input-group-text(@click="m_viewModal(d)" v-b-tooltip.hover.auto.ds500="{title: 'View ' + c_appEntName}")
								//- fa-icon(:icon="d_appEnt.icon" :color="d_appEnt.color")
								img(v-if="d_appEnt.key=='team' && d.profPic" :src="m_profPicURL(d[d_appEnt.idKey])")
								fa-icon(v-else :icon="d_appEnt.key=='team' ? 'user' : d_appEnt.icon" :color="d_appEnt.color")
							div(class="content" :class="d.classes"
								:title="d[d_appEnt.nameKey] + (d.recDesc? ' ('+d.recDesc+')':'')")
								span(class="num-link" v-if="c_showRecNum" @click="m_viewModal(d)") {{d[d_appEnt.numKey]}}
								span(class="name-text") {{d[d_appEnt.nameKey]}}
								span(class="rec-desc" v-if="d.recDesc") ({{d.recDesc}})
								b-button(v-if="!p_readOnly" class="btn-remove" variant="none" title="Remove" @click="m_onClickClear(ix)")
									fa-icon(icon="times")
					//- None Added
					div(class="none-added" v-if="p_readOnly || !p_enableAdd" v-show="c_listCount==0")
						span No {{d_appEnt.label}} Added
					//- KT-Select
				kt-select(v-if="!p_readOnly && p_enableAdd" ref="kt-select"
					:p_appEntKey="p_appEntKey" 
					:p_dfltOpts="p_dfltOpts"
					:p_dfltOptsLbl="p_dfltOptsLbl" 
					:p_filterKey="p_filterKey"
					:p_filterFirstKey="p_filterFirstKey"
					@change="m_addExistingToList"
					:p_required="p_required&&!c_listCount"
				)
			b-button(v-if="!p_readOnly && p_enableCreate" variant="none" class="btn-add-new" 
				v-b-tooltip.hover.auto.ds500="{title: 'Create a New ' + c_appEntName}"  @click="m_createNew_Modal()")
				fa-icon(icon="folder-plus")
		//- Show More/Less
		b-list-group-item(v-if="c_listCount>3" class="small p-0 pt-1 border-0 d-flex justify-content-start") 
			span(class="badge badge-primary px-1 mx-1 align-self-center") {{c_listCount}}
			span(class="btn btn-sm btn-link py-0 px-0" @click="d_showAll = !d_showAll") Show {{d_showAll?'Less⯅':'More⯆'}}

</template>

<script>
import {fn_appEnt, userSettings} from "@/utils/ref-data.js";
import {fn_humanizeLabel, kbdpAlert, fn_profilePicURL, fn_hrefVwRec} from "@/utils/util.js";
export default {
	name: "kt-list",
	components: {},
	created() {},
	mounted() {
		let rw = this.$el.closest('.rec-wrap');
		if (rw) {
			this.d_recWrapVC = rw.__vue__;
		}

	},
	data() {
		return {
			d_appEnt: fn_appEnt(this.p_appEntKey),
			d_showAll: false,
			d_added: this.p_currentVals || [],
			d_recWrapVC: null,//Set when mounted
		};
	},
	props: {
		p_appEntKey: String,
		p_currentVals: Array,
		p_readOnly: Boolean,
		p_enableCreate: Boolean,
		p_enableAdd: Boolean,
		p_filterKey: String,
		p_filterFirstKey:String,
		p_dfltOpts: Array,
		p_dfltOptsLbl: String,
		p_required: {type: Boolean, default: false},
	},
	computed: {
		c_appEntName() {
			return fn_humanizeLabel(this.d_appEnt.name);
		},
		c_listCount() {
			return (this.d_added || []).length;
		},
		c_showRecNum() {
			return userSettings.userOptions.showRecordNumbers;
		}
	},
	methods: {
		m_viewModal(recHdr) {
			let recNo = recHdr[this.d_appEnt.numKey];
			if (!recNo) return;

			let rw = this.d_recWrapVC;
			if (rw && rw.d_bmId) {
				rw.d_modal.appEntKey = this.p_appEntKey;
				rw.d_modal.recNo = recNo;
				this.$bvModal.show(rw.d_bmId);
			}
			else {
				let href = fn_hrefVwRec(this.p_appEntKey, recNo);
				window.open(href, '_blank');
			}
		},
		m_createNew_Modal() {
			let rw = this.d_recWrapVC;
			if (!rw || !rw.d_bmId) return;
			rw.d_modal.appEntKey = this.p_appEntKey;
			rw.d_modal.createNew = this.p_enableCreate;
			rw.d_modal.saveNewFn = this.m_saveNew_Modal;
			this.$bvModal.show(rw.d_bmId);
		},
		m_saveNew_Modal() {
			let _this = this;
			let rw = _this.d_recWrapVC;
			if (!rw) return;
			rw.$refs['rec-create-new'].m_saveFn().then(resp => {
				if (!resp.newRecHdr) {
					let msg = 'Unable to create ' + _this.c_appEntName + '. ' + resp.errorMessage;
					kbdpAlert.showErr(msg);
					return;
				}

				resp.newRecHdr.classes = ['added'];
				_this.d_added.push(resp.newRecHdr);
				_this.$emit('change', _this.d_added);
				_this.$bvModal.hide(rw.d_bmId);

				let msg = resp.newRecHdr[_this.d_appEnt.nameKey] + ' is Created Successfully.';
				kbdpAlert.showOk(msg);
			});
		},
		m_addExistingToList(val) {
			let sel = this.$refs['kt-select'];
			if (sel.c_isInvalid || sel.c_isEmpty) return;

			let idkey = this.d_appEnt.idKey;
			let existing = this.d_added.filter(x => x[idkey] == val[idkey])[0];

			if (existing) {
				if (existing.classes) existing.classes.push('highlight');
				else this.$set(existing, 'classes', ['highlight']);
				setTimeout(() => {existing.classes.pop();}, 1500);
			}
			else {
				let valAdd = {...val, classes: ['added']};
				this.d_added.push(valAdd);
				this.$emit('change', this.d_added);

				// if (!this.d_showAll && this.d_added.length > 3) {
				// 	this.d_showAll = true;
				// }
			}

			sel.m_clearSelOpt();
		},
		m_onClickClear(ix) {
			this.d_added.splice(ix, 1);
			this.$emit('change', this.d_added);
		},

		m_profPicURL(tmId) {
			return fn_profilePicURL(tmId);
		},
	},
	watch: {
		p_currentVals: function(val) {
			this.d_added = val || [];

			if (this.d_added.length <= 3) this.d_showAll = null;
		}
	}
};

</script>

<style lang="less">
.kt-list {
	.list-outer {
		display: flex;

		.list-inner {
			flex-grow: 1;
			border-bottom: solid 0.1em #dee2e6;
			border-radius: 0.25em;
			> .list-content {
				// border-radius: 0.25rem;

				overflow-y: auto;
				.list-item {
					display: flex;
					font-size: 0.9em;
					margin: 0.2em 0em;
					div.input-group-prepend {
						// position: relative;
						flex: 1 1 auto;
						margin: 0 0.2em;
					}
					div.input-group-text {
						font-size: 0.8em;
						&:hover {
							cursor: pointer;
							background-color: #dee2e6;
						}
						> img {
							border-radius: 0.75em;
							height: 22px;
							margin: auto 0;
							// display: none;
						}
					}
					div.content {
						// display: flex;
						position: relative;
						flex-grow: 1;
						border-bottom: solid 1px #ced4da;
						border-top-right-radius: 0.25em;
						border-bottom-right-radius: 0.25em;

						///***
						margin: auto 0;
						-ms-word-break: break-all;
						word-break: break-all;
						overflow: hidden;
						text-overflow: ellipsis;
						display: -webkit-box;
						-webkit-line-clamp: 1; /* number of lines to show */
						-webkit-box-orient: vertical;

						span {
							padding: 0.1em 0em;
							line-height: 1em;
						}
						span.num-link {
							flex-shrink: 0;
							color: #4fa4ff;
							cursor: pointer;
							&:hover {
								text-decoration: underline;
							}
						}
						span.name-text {
							&:nth-child(2)::before {
								padding: 0 0.1em;
								content: "-";
							}
						}
						span.rec-desc {
							font-size: 0.9em;
							padding-left: 0.3em;
							color: #adb5bd;
						}
						.btn-remove {
							position: absolute;
							top: 0;
							right: 0;
							padding: 0 0.3em;
							margin: 0.2em;

							opacity: 0.4;
							font-size: 0.8em;
							background-color: #e9ecef;
							&:hover {
								opacity: unset;
							}
						}

						&.added span.name-text::after {
							content: " +";
							font-weight: bold;
							color: #4fa4ff;
						}
						&.highlight span:not(:last-child) {
							background-color: rgba(79, 164, 255, 0.1);
							font-weight: bolder;
							// font-size: 0.9em;
							// transition-duration: 0.75s;
						}
					}
				}
				.none-added {
					font-size: 0.9em;
					margin: 0.2em 0.2em;
					padding: 0.1em 0.3em;
				}
			}
			> .list-content.show-all {
				resize: vertical;
				height: 200px;
				min-height: 100px;
				max-height: 400px;
				// overflow-y: auto;
			}
			.kt-select {
				.input-group-prepend {
					flex: 1 1 auto;
					margin: 0.2em;
					// margin-top: 0.5em;
				}
				// .sel-cont {
				// }
				// .options-container {
				// 	// z-index: 500;
				// }
			}
		}

		.btn-add-new {
			padding: 0 0.25em;
			margin: auto 0.25em;
			color: #4fa4ff;
			&:hover {
				background-color: #dee2e6;
			}
		}
	}

	&:not(.read-only) .content {
		padding: 0.1em 1.25em 0.1em 0.2em;
		&:hover {
			background-color: #f8f9fa;
		}
	}

	&.read-only {
		.content,
		.none-added {
			padding: 0.1em 0.3em;
			background-color1: #e9ecef;
		}
	}
}
</style>